import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-msp-company-risk',
  templateUrl: './msp-company-risk.component.html'
})
export class MspCompanyRiskComponent implements OnInit {
  @Input() companyData;

  riskGradient = [
    '#FF0000',
    '#FF3800',
    '#FF7100',
    '#FFAA00',
    '#FFE200',
    '#E2FF00',
    '#A9FF00',
    '#71FF00',
    '#38FF00',
    '#00FF00'];

  constructor() { }

  ngOnInit() {
  }

  getRiskColor(val) {
    const lvl = Math.floor(val / 10);
    return this.riskGradient[lvl];
  }

  getRiskLabel(val) {
    const lvl = Math.floor(val / 10);
    if (lvl <= 3) {
      return 'High';
    } else if (lvl <= 6) {
      return 'Medium';
    } else {
      return 'Low';
    }
  }
}
